import { shouldShowAdminRelease, type ReleaseMap } from './seenRelease.ts';

// Keyed by user id so a dismissal or open request never carries over to the next login.
export interface WhatsNewUiState {
    openedBy: string | null;
    dismissedBy: string | null;
}

export interface WhatsNewViewer {
    userId: string | null;
    releases: ReleaseMap | undefined;
    release: string;
}

export const INITIAL_WHATS_NEW_STATE: WhatsNewUiState = { openedBy: null, dismissedBy: null };

export function openedWhatsNew(state: WhatsNewUiState, userId: string): WhatsNewUiState {
    return { ...state, openedBy: userId };
}

export function closedWhatsNew(_state: WhatsNewUiState, userId: string): WhatsNewUiState {
    return { openedBy: null, dismissedBy: userId };
}

export function isWhatsNewOpen(state: WhatsNewUiState, viewer: WhatsNewViewer): boolean {
    const { userId, releases, release } = viewer;
    if (!userId || !releases) return false;
    if (state.openedBy === userId) return true;
    return state.dismissedBy !== userId && shouldShowAdminRelease(releases, release);
}
